import React from "react";
import { Link } from "react-router-dom";

function Cookies({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className='cookiescnt'>
      <div className='cookiescntleft'>
        <p className='cookiespara'>
          We only have to do this once! We use cookies to give you the best
          experience. To learn more about our cookies, check out our{" "}
          <span>Privacy Policy</span>
        </p>
      </div>
      <div className='cookiescntright'>
        <button className="cookiesacptbtn" onClick={onClose}>Accept cookies</button>
        <Link to='/' className="cookieslink">Learn more</Link>
      </div>
    </div>
  );
}

export default Cookies;
